































import Vue from 'vue';
import { getQueryParamsMap } from '@/app/tools/queryString';
import { serviceEvents, serviceEventsMap } from '@/app/events';
import { ServerType } from '@/modules/Metrix/LazyMetrixInstaller';
import { getMetrikaInstance } from '@/modules/Metrix/adapters/YandexMetrika';

export default Vue.extend({
    name: 'App',

    methods: {
        onMainBtnClick() {
            this.$relay.transmit(serviceEvents.MAIN_PAGE_BUTTON_CLICK);
            setTimeout(() => {
                window.open('http://auth.wi-fi.ru', '_system', 'location=yes');
            }, 120);
        },
    },

    mounted() {
        this.$relay.transmit(serviceEvents.MAIN_PAGE);
    },

    created() {
        this.$relay.registerEvents(serviceEventsMap);

        this.$metrics
            .metrika(ServerType.PROD)
            .then(() => {
                Object.defineProperty(window, 'mt_metrika', {
                    value: getMetrikaInstance(),
                });

                window.dispatchEvent(new Event('onMetrikaInstalled'));
            })
            .catch((error) => {
                console.error(error);
                this.$relay.transmit(serviceEvents.METRIKA_FAILED);
            });

        const { mac, segment, session_id } = getQueryParamsMap();

        this.$metrics
            .divolte({
                sessionId: session_id!,
                mac: mac!,
                ObjSegment: segment!,
                ObjService:
                    process.env.VUE_APP_ENVIRONMENT === 'production'
                        ? ServerType.PROD
                        : `welcome_${process.env.VUE_APP_ENVIRONMENT ||
                              'local'}`,
                remoteHostInt: undefined!,
                rootObjName: 'welcome.wi-fi.ru',
            })
            .catch((error) => {
                console.error(error);
                this.$relay.transmit(serviceEvents.CSC_FAILED);
            });
    },
});
